import styled from "styled-components";

export const Container = styled.div`
    width: 500px;
    display: flex;
    flex-direction: column;
    margin-bottom: 1em;
`

export const Title = styled.h3`
    color: white;
    margin-bottom: .1em;
`

export const Text = styled.p`
    color: white;
    margin-bottom: .1em;
`

export const InstructionList = styled.ul`

`

export const Button = styled.button`
    color: black;
    padding: 5px;
    cursor: pointer;
`

export const LoginButtonContainer = styled.div`
    display: flex;
`

export const LoginButton = styled.button`
    color: black;
    padding: 5px;
    flex: 1;
    margin: .5em;
    cursor: pointer;
    width: 25%;
`

export const ServerButton = styled.div`
    color: black;
    padding: 5px;
    flex: 1;
    margin: .5em;
    cursor: pointer;
`